import axios from "axios";
import {
  ExperiencesShopReviewsRequest,
  ExperiencesShopReviewsResponse,
} from "redmond";
import { config } from "../../config";
import { experiencesShopReviewsApiPrefix } from "../paths";

export const fetchExperiencesShopReviews = async (
  body: ExperiencesShopReviewsRequest
): Promise<ExperiencesShopReviewsResponse> => {
  const res = await axios.post(experiencesShopReviewsApiPrefix, body, {
    baseURL: config.baseURL,
  });

  return res.data.value;
};
